import { forwardRef, Icon, IconProps } from '@chakra-ui/react';
import { useIconId } from '../utils';

const AppStoreColor = forwardRef<IconProps, 'svg'>((props, ref) => {
  const iconPrefix = useIconId();
  return (
    <Icon ref={ref} viewBox="0 0 24 24" {...props}>
      <path
        d="M17.96 2H6.04C3.8075 2 2 3.8075 2 6.04V17.9625C2 20.1925 3.8075 22 6.04 22H17.9625C20.1925 22 22.0025 20.1925 22.0025 17.96V6.04C22 3.8075 20.1925 2 17.96 2Z"
        fill={`url(#${iconPrefix}__a)`}
      />
      <path
        d="M11.9162 6.595L12.3213 5.895C12.5713 5.4575 13.1289 5.31 13.5664 5.56C14.004 5.81 14.1515 6.3675 13.9015 6.805L9.9985 13.56H12.8214C13.7365 13.56 14.249 14.635 13.8515 15.38H5.57545C5.07038 15.38 4.66533 14.975 4.66533 14.47C4.66533 13.965 5.07038 13.56 5.57545 13.56H7.89574L10.8661 8.4125L9.93849 6.8025C9.68846 6.365 9.83598 5.8125 10.2735 5.5575C10.7111 5.3075 11.2637 5.455 11.5187 5.8925L11.9162 6.595ZM8.4058 16.3175L7.53069 17.835C7.28066 18.2725 6.72309 18.42 6.28553 18.17C5.84798 17.92 5.70046 17.3625 5.95049 16.925L6.60057 15.8C7.33567 15.5725 7.93324 15.7475 8.4058 16.3175ZM15.9417 13.565H18.3095C18.8146 13.565 19.2197 13.97 19.2197 14.475C19.2197 14.98 18.8146 15.385 18.3095 15.385H16.9944L17.882 16.925C18.132 17.3625 17.9845 17.915 17.5469 18.17C17.1094 18.42 16.5568 18.2725 16.3018 17.835C14.8066 15.2425 13.684 13.3025 12.9389 12.01C12.1763 10.695 12.7213 9.375 13.2589 8.9275C13.8565 9.9525 14.7491 11.5 15.9417 13.565Z"
        fill="#fff"
      />
      <defs>
        <linearGradient gradientUnits="userSpaceOnUse" id={`${iconPrefix}__a`} x1={12.0012} x2={12.0012} y1={2} y2={22}>
          <stop stopColor="#18BFFB" />
          <stop offset={1} stopColor="#2072F3" />
        </linearGradient>
      </defs>
    </Icon>
  );
});

export default AppStoreColor;
